var exports = {
  "O": "conversationListHeading__sq5lAQ",
  "v": "inner__HNzkM0",
};

module.exports = exports;
